import {MdxEditorCustomButtonType} from 'components/MdxEditorField/helper';

export const getFilteredItems = (
    items: MdxEditorCustomButtonType[],
    search: string | null,
    hasSearchByCustomButtonOptions?: boolean,
): MdxEditorCustomButtonType[] => {
    if (hasSearchByCustomButtonOptions && search && search.length > 2) {
        const results: MdxEditorCustomButtonType[] = [];
        const searchLowerCase = search.toLowerCase();
        items.forEach(item => {
            const {title, parentTitle, isSubItem} = item;
            const titleLowerCase = title.toLowerCase();
            const parentTitleLowerCase = parentTitle ? parentTitle.toLowerCase() : '';
            if (
                (!isSubItem && titleLowerCase.includes(searchLowerCase)) ||
                (isSubItem && parentTitleLowerCase.includes(searchLowerCase))
            ) {
                results.push(item);
            }
        });
        return results;
    }
    return items;
};
